"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
exports.__esModule = true;
exports.FlightPriceDto = exports.FlightCheckInDatesDto = exports.FlightArrivalDto = exports.FlightDepartureDto = exports.PassengerDto = exports.DepartureDto = void 0;
var class_validator_1 = require("class-validator");
var class_transformer_1 = require("class-transformer");
var i18n_1 = require("../../i18n");
var currencies_1 = require("../../currencies");
var DepartureDto = (function () {
    function DepartureDto() {
    }
    __decorate([
        class_validator_1.IsString(),
        class_validator_1.IsIn(['CITY', 'AIRPORT']),
        __metadata("design:type", String)
    ], DepartureDto.prototype, "type");
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], DepartureDto.prototype, "id");
    return DepartureDto;
}());
exports.DepartureDto = DepartureDto;
var PassengerDto = (function () {
    function PassengerDto() {
    }
    __decorate([
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], PassengerDto.prototype, "count");
    __decorate([
        class_validator_1.IsIn(['ADULT', 'CHILD', 'INFANT', 'SENIOR', 'STUDENT', 'YOUNG', 'MILITARY', 'TEACHER']),
        __metadata("design:type", String)
    ], PassengerDto.prototype, "type");
    return PassengerDto;
}());
exports.PassengerDto = PassengerDto;
var FlightDepartureDto = (function () {
    function FlightDepartureDto() {
    }
    __decorate([
        class_validator_1.Validate(i18n_1.IsLangAvailable, {
            message: 'Invalid language code'
        }),
        __metadata("design:type", String)
    ], FlightDepartureDto.prototype, "language");
    __decorate([
        class_validator_1.Validate(currencies_1.IsCurrencyAvailable, {
            message: 'Invalid currency code'
        }),
        __metadata("design:type", String)
    ], FlightDepartureDto.prototype, "currency");
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], FlightDepartureDto.prototype, "query");
    __decorate([
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], FlightDepartureDto.prototype, "isRoundTrip");
    return FlightDepartureDto;
}());
exports.FlightDepartureDto = FlightDepartureDto;
var FlightArrivalDto = (function () {
    function FlightArrivalDto() {
    }
    __decorate([
        class_validator_1.Validate(i18n_1.IsLangAvailable, {
            message: 'Invalid language code'
        }),
        __metadata("design:type", String)
    ], FlightArrivalDto.prototype, "language");
    __decorate([
        class_validator_1.Validate(currencies_1.IsCurrencyAvailable, {
            message: 'Invalid currency code'
        }),
        __metadata("design:type", String)
    ], FlightArrivalDto.prototype, "currency");
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], FlightArrivalDto.prototype, "query");
    __decorate([
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], FlightArrivalDto.prototype, "isRoundTrip");
    __decorate([
        class_validator_1.ValidateNested(),
        class_transformer_1.Type(function () { return DepartureDto; }),
        __metadata("design:type", DepartureDto)
    ], FlightArrivalDto.prototype, "departure");
    return FlightArrivalDto;
}());
exports.FlightArrivalDto = FlightArrivalDto;
var FlightCheckInDatesDto = (function () {
    function FlightCheckInDatesDto() {
    }
    __decorate([
        class_validator_1.ValidateNested(),
        class_transformer_1.Type(function () { return DepartureDto; }),
        __metadata("design:type", DepartureDto)
    ], FlightCheckInDatesDto.prototype, "departure");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.ValidateNested(),
        class_transformer_1.Type(function () { return DepartureDto; }),
        __metadata("design:type", DepartureDto)
    ], FlightCheckInDatesDto.prototype, "arrival");
    return FlightCheckInDatesDto;
}());
exports.FlightCheckInDatesDto = FlightCheckInDatesDto;
var FlightPriceDto = (function () {
    function FlightPriceDto() {
    }
    __decorate([
        class_validator_1.ValidateNested(),
        class_transformer_1.Type(function () { return DepartureDto; }),
        __metadata("design:type", DepartureDto)
    ], FlightPriceDto.prototype, "departure");
    __decorate([
        class_validator_1.ValidateNested(),
        class_transformer_1.Type(function () { return DepartureDto; }),
        __metadata("design:type", DepartureDto)
    ], FlightPriceDto.prototype, "arrival");
    __decorate([
        class_validator_1.Validate(i18n_1.IsLangAvailable, {
            message: 'Invalid language code'
        }),
        __metadata("design:type", String)
    ], FlightPriceDto.prototype, "language");
    __decorate([
        class_validator_1.Validate(currencies_1.IsCurrencyAvailable, {
            message: 'Invalid currency code'
        }),
        __metadata("design:type", String)
    ], FlightPriceDto.prototype, "currency");
    __decorate([
        class_validator_1.IsDateString(),
        __metadata("design:type", String)
    ], FlightPriceDto.prototype, "checkIn");
    __decorate([
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], FlightPriceDto.prototype, "isRoundTrip");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], FlightPriceDto.prototype, "nights");
    __decorate([
        class_validator_1.IsArray(),
        class_validator_1.ValidateNested({ each: true }),
        class_transformer_1.Type(function () { return PassengerDto; }),
        __metadata("design:type", Array)
    ], FlightPriceDto.prototype, "passengers");
    return FlightPriceDto;
}());
exports.FlightPriceDto = FlightPriceDto;
//# sourceMappingURL=flight.dto.js.map